"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const value = schema_1.Schema.number()
    .expiration(31536000)
    .unit("U/l")
    .integer()
    .min(0)
    .max(9999)
    .interpretation({ vocab: "ktx", code: "lab_alkaline_phosphatase" })
    .tag({ vocab: "snomed", code: "88810008", source: "synonym" })
    .tag({ vocab: "loinc", code: "6768-6", source: "synonym" })
    .tag({ vocab: "ktx", code: "lab_procedure" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
